/*
 *  (c) 2015 - 2022 ENISCO by FORCAM GmbH
 */

import {List} from '@mui/material'
import React from 'react'
import ModuleViewer from './ModuleViewer'
import TabPanel from '../TabPanel'
import {clone, translateText, useLanguage} from '@enisco/mcc-react-lib'
import useRegisteredModules from '../../../../hooks/useRegisteredModules'

interface Props {
  handleClose: () => void
  value: number
  index: number
}

const AllAppsTab: React.FC<Props> = ({handleClose, value, index}) => {
  const [registeredModules] = useRegisteredModules()
  const language = useLanguage()

  const sortedModules = clone(registeredModules)

  sortedModules.sort((a, b) =>
    (translateText(language, a.description) || '').localeCompare(
      translateText(language, b.description) || ''
    )
  )

  return (
    <TabPanel value={value} index={index} data-testid={'AllAppsTab:root'}>
      <List>
        {sortedModules
          .filter((module) => !module.hidden)
          .map((module) => (
            <ModuleViewer
              handleClose={handleClose}
              module={module}
              key={module.name}
            />
          ))}
      </List>
    </TabPanel>
  )
}

export default AllAppsTab
